import { Component, OnInit, Input } from '@angular/core';
import { AuctionLead } from '@app-model/auction-lead';
import { OemDealerService, DealerInfo } from 'src/app/shared/services/oem-dealer.service';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-dealer-info-box',
  templateUrl: './dealer-info-box.component.html',
  styleUrls: ['./dealer-info-box.component.scss', '../make-final-bid/make-final-bid.component.scss']
})
export class DealerInfoBoxComponent implements OnInit {
  @Input() dealer: DealerInfo;
  @Input() isMarketplace: boolean;
  @Input() item: AuctionLead;

  constructor() { }

  ngOnInit(): void {
  }

}
